export default __webpack_public_path__ + "static/media/last-day-check-in-container.30a1ab07.webp";